import { Box } from '@mui/material';

import { Divider } from 'shared/components/Divider';

import { Wrapper } from './components/Wrapper';

import type { FC, PropsWithChildren as FooterWrapperProps } from 'react';

export const FooterWrapper: FC<FooterWrapperProps> = ({ children }) => (
  <Box marginLeft={4} marginRight={4}>
    <Divider />
    <Wrapper>{children}</Wrapper>
  </Box>
);
